
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("531JC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1b91c33fa3484455$export$3d5265f8773197d = ({ maxNumberOfItemsPerRow: maxNumberOfItemsPerRow, numberOfItems: numberOfItems, isRow: isRow })=>{
    // Indices represents the leftmost item and rightmost item currently in view.
    const [window, setWindow] = (0, $cozmU.useState)([
        0,
        0
    ]);
    // Used for scrolling to a particular item. Set to -1 by default as we haven't scrolled yet.
    const [scrollToIndex, setScrollToIndex] = (0, $cozmU.useState)(-1);
    // Used to keep track of which item is currently being edited in the config panel to adjust window accordingly.
    const [requestedScrollIndex, setRequestedScrollIndex] = (0, $cozmU.useState)(-1);
    (0, $cozmU.useEffect)(()=>{
        {
            // Viewable window indexes are inclusive of left and right index, so we need to decrement by one unless maxNumberOfItemsPerRow is 0.
            // Examples:
            // Cards: 1 2 3 4 5, Card indexes: 0 1 2 3 4
            // maxNumberOfItemsPerRow is 0, current left index is at card 1 (ie. index 0) --> right index should be at card 1 (index 0), 1 card in view. Calculation: 0 + 0 - 0 = 0
            // maxNumberOfItemsPerRow is 2, current left index is at card 1 (ie. index 0) --> right index should be at card 2 (index 1), 2 cards in view. Calculation: 0 + 2 - 1 = 1
            // maxNumberOfItemsPerRow is 3, current left index is at card 2 (ie. index 1) --> right index should be at card 4 (index 3), 3 cards in view. Calculation: 1 + 3 - 1 = 3
            const extraDecrement = maxNumberOfItemsPerRow === 0 ? 0 : 1;
            const newRightIndex = window[0] + maxNumberOfItemsPerRow - extraDecrement;
            setWindow([
                window[0],
                newRightIndex
            ]);
        }
        if (requestedScrollIndex >= 0) {
            // Trigger scroll unconditionally, this works for grid view as well (which doesn't use the window logic)
            setScrollToIndex(requestedScrollIndex);
            // Only update the window in row orientation, as we don't use a window for grid view.
            if (isRow) {
                if (requestedScrollIndex !== window[0] && requestedScrollIndex !== window[1]) {
                    // This means we've scrolled somewhere left beyond the existing visible window, so we update the window to the left.
                    if (requestedScrollIndex < window[0]) setWindow([
                        requestedScrollIndex,
                        requestedScrollIndex + maxNumberOfItemsPerRow - 1
                    ]);
                    else if (requestedScrollIndex > window[1]) setWindow([
                        requestedScrollIndex - maxNumberOfItemsPerRow + 1,
                        requestedScrollIndex
                    ]);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        maxNumberOfItemsPerRow,
        requestedScrollIndex,
        isRow
    ]);
    const scrollToPrevious = (0, $cozmU.useCallback)(()=>{
        const newLeftIndex = window[0] - 1;
        const newRightIndex = window[1] - 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newLeftIndex);
    }, [
        window
    ]);
    const scrollToNext = ()=>{
        const newLeftIndex = window[0] + 1;
        const newRightIndex = window[1] + 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newRightIndex);
    };
    (0, $cozmU.useEffect)(()=>{
        // If user deletes an item near the end of the list, our window of
        // items being shown may need recalculating (if right index is too high)
        if (window[1] > numberOfItems - 1 && window[0] > 0) scrollToPrevious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numberOfItems,
        scrollToPrevious
    ]);
    const noScrollNeeded = numberOfItems <= maxNumberOfItemsPerRow;
    const isAtBeginning = noScrollNeeded || window[0] === 0;
    const isAtEnd = noScrollNeeded || window[1] === numberOfItems - 1;
    const resetScrollIndex = ()=>{
        setScrollToIndex(-1);
    };
    return {
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext,
        scrollToIndex: scrollToIndex,
        requestScrollIndex: setRequestedScrollIndex,
        resetScrollIndex: resetScrollIndex
    };
};
module.exports["useOrientationScrolling"] = $1b91c33fa3484455$export$3d5265f8773197d;

});

parcelRegister("gMXXV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $386ef889bd883882$export$1a197eb476b94cd9 = 16;
const $386ef889bd883882$export$622d6c2ee56322dc = 16;
const $386ef889bd883882$var$MAX_NUMBER_OF_ITEMS_PER_ROW = 6;
const $386ef889bd883882$export$a6443181a5681c94 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { numberOfCards: numberOfCards, cardDimensions: cardDimensions, gapBetweenItems: t1, getItemDimensions: getItemDimensions } = t0;
    const gapBetweenItems = t1 === undefined ? $386ef889bd883882$export$1a197eb476b94cd9 : t1;
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $cozmU.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $cozmU.useState)(0);
    let t2;
    if ($[0] !== cardDimensions || $[1] !== getItemDimensions) {
        t2 = getItemDimensions ? getItemDimensions() : cardDimensions;
        $[0] = cardDimensions;
        $[1] = getItemDimensions;
        $[2] = t2;
    } else t2 = $[2];
    const dimensions = t2;
    const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + gapBetweenItems) / (dimensions.minWidth + gapBetweenItems));
    const maxNumberOfCardsPerRow = Math.min(numberOfCardsPerRow, $386ef889bd883882$var$MAX_NUMBER_OF_ITEMS_PER_ROW);
    if (currentCardsGridWidthAdjustedForRounding <= dimensions.minWidth) {
        let t3;
        if ($[3] !== gapBetweenItems) {
            t3 = {
                spaceBetweenCards: gapBetweenItems,
                paddingRightGapOffset: 0
            };
            $[3] = gapBetweenItems;
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== dimensions.minWidth || $[6] !== maxNumberOfCardsPerRow || $[7] !== t3) {
            t4 = {
                calculations: {
                    cardWidthOnFullRow: dimensions.minWidth,
                    isFirstRowFull: true,
                    isFirstRowOverflown: false,
                    isGridSmallerOrEqualWidthToCards: true,
                    gaps: t3,
                    maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
                },
                setCurrentCardsGridWidth: setCurrentCardsGridWidth,
                setCurrentCardWidth: setCurrentCardWidth
            };
            $[5] = dimensions.minWidth;
            $[6] = maxNumberOfCardsPerRow;
            $[7] = t3;
            $[8] = t4;
        } else t4 = $[8];
        return t4;
    }
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - gapBetweenItems * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, dimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * gapBetweenItems;
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, $386ef889bd883882$export$622d6c2ee56322dc - $386ef889bd883882$export$1a197eb476b94cd9);
    const spaceBetweenCards = gapBetweenItems + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    let t3;
    if ($[9] !== paddingRightGapOffset || $[10] !== spaceBetweenCards) {
        t3 = {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        };
        $[9] = paddingRightGapOffset;
        $[10] = spaceBetweenCards;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== cardWidthOnFullRow || $[13] !== isFirstRowFull || $[14] !== isFirstRowOverflown || $[15] !== maxNumberOfCardsPerRow || $[16] !== t3) {
        const calculations = {
            cardWidthOnFullRow: cardWidthOnFullRow,
            isFirstRowFull: isFirstRowFull,
            isFirstRowOverflown: isFirstRowOverflown,
            isGridSmallerOrEqualWidthToCards: false,
            gaps: t3,
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        };
        t4 = {
            calculations: calculations,
            setCurrentCardsGridWidth: setCurrentCardsGridWidth,
            setCurrentCardWidth: setCurrentCardWidth
        };
        $[12] = cardWidthOnFullRow;
        $[13] = isFirstRowFull;
        $[14] = isFirstRowOverflown;
        $[15] = maxNumberOfCardsPerRow;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, gapBetweenItems: gapBetweenItems = $386ef889bd883882$export$1a197eb476b94cd9, getItemDimensions: getItemDimensions })=>{
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $cozmU.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $cozmU.useState)(0);
    const dimensions = getItemDimensions ? getItemDimensions() : cardDimensions;
    /*
   * Width observer rounds the width of the container (currentCardsGridWidth) returning a whole number.
   * This means in situations that the width is rounded up, we have an edge case where we are
   * making calculations with a grid width larger than what we actually have leading to layout issues.
   *
   * It is better to adjust the width we get from the observer down (-.5px) and
   * have some cases where we have extra space (<=.5px) than the latter problem that causes layout issues.
   */ const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + gapBetweenItems) / (dimensions.minWidth + gapBetweenItems));
    const maxNumberOfCardsPerRow = Math.min(numberOfCardsPerRow, $386ef889bd883882$var$MAX_NUMBER_OF_ITEMS_PER_ROW);
    if (currentCardsGridWidthAdjustedForRounding <= dimensions.minWidth) return {
        calculations: {
            cardWidthOnFullRow: dimensions.minWidth,
            isFirstRowFull: true,
            isFirstRowOverflown: false,
            isGridSmallerOrEqualWidthToCards: true,
            gaps: {
                spaceBetweenCards: gapBetweenItems,
                paddingRightGapOffset: 0
            },
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        },
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - gapBetweenItems * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, dimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * gapBetweenItems;
    // Preserve the original gap-distribution behaviour: any extra (or negative
    // rounding) space is spread across the gaps, capped at how much the gap is
    // allowed to grow beyond its minimum (MAX_GAP - MIN_GAP). This keeps the math
    // identical for the default gap while still honouring a larger space-density
    // `gapBetweenItems`.
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, $386ef889bd883882$export$622d6c2ee56322dc - $386ef889bd883882$export$1a197eb476b94cd9);
    const spaceBetweenCards = gapBetweenItems + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    const calculations = {
        cardWidthOnFullRow: cardWidthOnFullRow,
        isFirstRowFull: isFirstRowFull,
        isFirstRowOverflown: isFirstRowOverflown,
        isGridSmallerOrEqualWidthToCards: false,
        gaps: {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        },
        maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
    };
    return {
        calculations: calculations,
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
};
module.exports["useWidthAndSpacingCalculations"] = $386ef889bd883882$export$a6443181a5681c94;

});

parcelRegister("5D0gt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $1LXnB = parcelRequire("1LXnB");


var $bIp5p = parcelRequire("bIp5p");


var $hjUDQ = parcelRequire("hjUDQ");

const $e48d13805ad5c50c$export$efa81a508b70a345 = {
    [(0, $hjUDQ.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $e48d13805ad5c50c$export$1928c8795f1f40c6 = (cardSize)=>{
    return $e48d13805ad5c50c$export$efa81a508b70a345[cardSize];
};
const $e48d13805ad5c50c$var$styles = {
    wrapperStyles: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4c065UFQfX _1mT5xdRAKS _0aNu0LYbGa _313842Pgdg",
    wrapperStylesUpdated: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1mT5xdRAKS _0aNu0LYbGa _313842Pgdg",
    wrapperWithInlinePadding: "_2Y7lL4FQfX"
};
const $e48d13805ad5c50c$export$11b226df951ea813 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, setWidth: setWidth, testId: t1, scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, itemDimensions: itemDimensions, hasInlinePadding: t2, ariaRole: ariaRole } = t0;
    const testId = t1 === undefined ? "card-wrapper" : t1;
    const hasInlinePadding = t2 === undefined ? false : t2;
    const cardRef = (0, $cozmU.useRef)(null);
    const [t3] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId } = t3;
    const cardDimensions = itemDimensions;
    let t4;
    let t5;
    if ($[0] !== cardId || $[1] !== clearScrollToCard || $[2] !== extensionLocalId || $[3] !== index || $[4] !== requestScrollIndex || $[5] !== scrollToCard || $[6] !== selectedExtensionLocalId || $[7] !== selectedToEditCardId) {
        t4 = ()=>{
            const scrollIntoViewBehavior = {
                behavior: "smooth",
                block: "nearest",
                inline: "nearest"
            };
            if (cardRef.current) {
                if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                    cardRef.current.scrollIntoView(scrollIntoViewBehavior);
                    clearScrollToCard();
                }
                if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) requestScrollIndex(index);
                else if (!selectedToEditCardId) requestScrollIndex(-1);
            }
        };
        t5 = [
            cardRef,
            cardId,
            extensionLocalId,
            index,
            scrollToCard,
            clearScrollToCard,
            selectedExtensionLocalId,
            selectedToEditCardId,
            requestScrollIndex
        ];
        $[0] = cardId;
        $[1] = clearScrollToCard;
        $[2] = extensionLocalId;
        $[3] = index;
        $[4] = requestScrollIndex;
        $[5] = scrollToCard;
        $[6] = selectedExtensionLocalId;
        $[7] = selectedToEditCardId;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.minWidth}px`;
    const t7 = isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.maxWidth}px`;
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = {
            minWidth: t6,
            maxWidth: t7
        };
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    const t9 = hasInlinePadding && $e48d13805ad5c50c$var$styles.wrapperWithInlinePadding;
    let t10;
    if ($[13] !== t9) {
        t10 = (0, $hekY6.default)([
            (0, $iDrrr.fg)("enable_jsm_help_extension_redesign") ? $e48d13805ad5c50c$var$styles.wrapperStylesUpdated : $e48d13805ad5c50c$var$styles.wrapperStyles,
            t9
        ]);
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== index || $[16] !== setWidth) {
        t11 = index === 0 && setWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: setWidth,
            offscreen: true
        });
        $[15] = index;
        $[16] = setWidth;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== ariaRole || $[19] !== children || $[20] !== t10 || $[21] !== t11 || $[22] !== t8 || $[23] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: ariaRole,
            style: t8,
            ref: cardRef,
            "data-testid": testId,
            className: t10
        }, children, t11);
        $[18] = ariaRole;
        $[19] = children;
        $[20] = t10;
        $[21] = t11;
        $[22] = t8;
        $[23] = testId;
        $[24] = t12;
    } else t12 = $[24];
    return t12;
} : ({ children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, setWidth: setWidth, testId: testId = 'card-wrapper', scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, itemDimensions: itemDimensions, hasInlinePadding: hasInlinePadding = false, ariaRole: ariaRole })=>{
    const cardRef = (0, $cozmU.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId }] = (0, $bIp5p.useExtensionsState)();
    const cardDimensions = itemDimensions;
    (0, $cozmU.useEffect)(()=>{
        const scrollIntoViewBehavior = {
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        };
        if (cardRef.current) {
            // Scroll to this card as long as its config panel is open OR no config panel is open.
            // If no config panel is open, that covers the case in edit mode where user has clicked
            // scroll buttons on a row-oriented cards instance which they aren't actively editing.
            if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                cardRef.current.scrollIntoView(scrollIntoViewBehavior); // Clear scrollIndex to prevent re-invoking scroll effect later unexpectedly
                clearScrollToCard();
            } // Handle the case where user has selected this card to edit from the config panel.
            if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) // Now that we've reached the right card that user is selecting to edit,
            // trigger the scrolling hook to recalculate scroll window and index so
            // that we can rerender invoking the scroll effect
            requestScrollIndex(index);
            else if (!selectedToEditCardId) // if no card is selected to edit, set index to -1 indicate that it is not currently being used
            requestScrollIndex(-1);
        }
    }, [
        cardRef,
        cardId,
        extensionLocalId,
        index,
        scrollToCard,
        clearScrollToCard,
        selectedExtensionLocalId,
        selectedToEditCardId,
        requestScrollIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: ariaRole,
        style: {
            minWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.minWidth}px`,
            maxWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.maxWidth}px`
        },
        ref: cardRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            (0, $iDrrr.fg)('enable_jsm_help_extension_redesign') ? $e48d13805ad5c50c$var$styles.wrapperStylesUpdated : $e48d13805ad5c50c$var$styles.wrapperStyles,
            hasInlinePadding && $e48d13805ad5c50c$var$styles.wrapperWithInlinePadding
        ])
    }, children, index === 0 && setWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        setWidth: setWidth,
        offscreen: true
    }));
};
module.exports["CardOrientationWrapper"] = $e48d13805ad5c50c$export$11b226df951ea813;

});

parcelRegister("9QaSD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cfM7x = parcelRequire("cfM7x");

const $7671493751624151$export$9e87ed1f12141293 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cardId, link, onCardSucceeded, onCardFailed)=>{
    const $ = (0, $bDgLe.c)(21);
    const [isResolved, setIsResolved] = (0, $cozmU.useState)(false);
    const [errorCardStatus, setErrorCardStatus] = (0, $cozmU.useState)("");
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const shouldPreserveErrorStatus = (0, $cozmU.useRef)(false);
    const isRestricted = errorCardStatus === "forbidden";
    const isUnauthorized = errorCardStatus === "unauthorized";
    const isNoResult = errorCardStatus === "not_found";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            setErrorCardStatus("");
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== link) {
        t1 = [
            link,
            setErrorCardStatus
        ];
        $[1] = link;
        $[2] = t1;
    } else t1 = $[2];
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== onCardFailed || $[4] !== submitError) {
        t2 = (err)=>{
            onCardFailed(err);
            submitError?.(err);
        };
        $[3] = onCardFailed;
        $[4] = submitError;
        $[5] = t2;
    } else t2 = $[5];
    const failExperienceAndSendErrorMonitoring = t2;
    let t3;
    if ($[6] !== cardId || $[7] !== failExperienceAndSendErrorMonitoring || $[8] !== onCardSucceeded) {
        t3 = (t4)=>{
            const { status: status, err: err_0 } = t4;
            setErrorCardStatus(status);
            setIsResolved(true);
            if (status === "unauthorized") shouldPreserveErrorStatus.current = true;
            if (err_0) failExperienceAndSendErrorMonitoring(err_0);
            else onCardSucceeded(cardId);
        };
        $[6] = cardId;
        $[7] = failExperienceAndSendErrorMonitoring;
        $[8] = onCardSucceeded;
        $[9] = t3;
    } else t3 = $[9];
    const trackAndCategorizeError = t3;
    let t4;
    if ($[10] !== cardId || $[11] !== onCardSucceeded) {
        t4 = ()=>{
            onCardSucceeded(cardId);
            setIsResolved(true);
            if (shouldPreserveErrorStatus.current) {
                shouldPreserveErrorStatus.current = false;
                return;
            }
            setErrorCardStatus("");
        };
        $[10] = cardId;
        $[11] = onCardSucceeded;
        $[12] = t4;
    } else t4 = $[12];
    const trackSuccess = t4;
    let t5;
    if ($[13] !== errorCardStatus || $[14] !== isNoResult || $[15] !== isResolved || $[16] !== isRestricted || $[17] !== isUnauthorized || $[18] !== trackAndCategorizeError || $[19] !== trackSuccess) {
        t5 = {
            isNoResult: isNoResult,
            isRestricted: isRestricted,
            isUnauthorized: isUnauthorized,
            errorCardStatus: errorCardStatus,
            isResolved: isResolved,
            trackAndCategorizeError: trackAndCategorizeError,
            trackSuccess: trackSuccess
        };
        $[13] = errorCardStatus;
        $[14] = isNoResult;
        $[15] = isResolved;
        $[16] = isRestricted;
        $[17] = isUnauthorized;
        $[18] = trackAndCategorizeError;
        $[19] = trackSuccess;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : (cardId, link, onCardSucceeded, onCardFailed)=>{
    const [isResolved, setIsResolved] = (0, $cozmU.useState)(false);
    const [errorCardStatus, setErrorCardStatus] = (0, $cozmU.useState)('');
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const shouldPreserveErrorStatus = (0, $cozmU.useRef)(false);
    // Other error types [`errored`, `fallback`] should not be caught. We will let the card UI render, even though
    // the SmartCard cannot fetch data for them
    const isRestricted = errorCardStatus === 'forbidden';
    const isUnauthorized = errorCardStatus === 'unauthorized';
    const isNoResult = errorCardStatus === 'not_found';
    (0, $cozmU.useEffect)(()=>{
        setErrorCardStatus('');
    }, [
        link,
        setErrorCardStatus
    ]);
    const failExperienceAndSendErrorMonitoring = (0, $cozmU.useCallback)((err)=>{
        onCardFailed(err);
        submitError?.(err);
    }, [
        onCardFailed,
        submitError
    ]);
    const trackAndCategorizeError = (0, $cozmU.useCallback)(({ status: status, err: err_0 })=>{
        setErrorCardStatus(status);
        setIsResolved(true);
        if (status === 'unauthorized') shouldPreserveErrorStatus.current = true;
        if (err_0) failExperienceAndSendErrorMonitoring(err_0);
        else onCardSucceeded(cardId);
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded,
        failExperienceAndSendErrorMonitoring
    ]);
    const trackSuccess = (0, $cozmU.useCallback)(()=>{
        onCardSucceeded(cardId);
        setIsResolved(true);
        // For Smart Cards with an unauthorized state, it calls onResolve, but we don't want to clear the error status.
        // shouldPreserveErrorStatus is used b/c we need to skip clearing the error status for one cycle
        if (shouldPreserveErrorStatus.current) {
            shouldPreserveErrorStatus.current = false;
            return;
        }
        setErrorCardStatus('');
    }, [
        setErrorCardStatus,
        cardId,
        onCardSucceeded
    ]);
    return {
        isNoResult: isNoResult,
        isRestricted: isRestricted,
        isUnauthorized: isUnauthorized,
        errorCardStatus: errorCardStatus,
        isResolved: isResolved,
        trackAndCategorizeError: trackAndCategorizeError,
        trackSuccess: trackSuccess
    };
};
module.exports["useTrackedSmartCardState"] = $7671493751624151$export$9e87ed1f12141293;

});


//# sourceMappingURL=cards-extension.9358a861.js.map
